"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _uuid = require("uuid");
var _reactI18next = require("react-i18next");
var _stopDefault = _interopRequireDefault(require("@teladoc/pulse/icons/stop-default.svg"));
var _alertDefault = _interopRequireDefault(require("@teladoc/pulse/icons/alert-default.svg"));
var _checkCircleDefault = _interopRequireDefault(require("@teladoc/pulse/icons/check-circle-default.svg"));
var _infoDefault = _interopRequireDefault(require("@teladoc/pulse/icons/info-default.svg"));
var _Button = _interopRequireDefault(require("@teladoc/pulse/ui/Button"));
var _DismissButton = _interopRequireDefault(require("../DismissButton"));
var _NotificationModule = _interopRequireDefault(require("./Notification.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const ICONS = {
  info: _infoDefault.default,
  success: _checkCircleDefault.default,
  warning: _alertDefault.default,
  critical: _stopDefault.default
};
const Notification = _ref => {
  let {
    buttonText,
    closeToast,
    icon,
    toastProps,
    classNameContent,
    onClick,
    testAttrContent,
    testAttrDismiss,
    type,
    title,
    message,
    showActionButton,
    i18nDismissLabel,
    variant,
    onFocus
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const {
    current: Icon
  } = (0, _react.useRef)(ICONS[type]);
  const titleId = "".concat(uuid, "-title");
  const messageId = "".concat(uuid, "-message");
  const actionButtonWithText = showActionButton && buttonText;
  const notificationContent = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cnbuilder.cnb)(_NotificationModule.default.content, classNameContent),
    "aria-atomic": "true",
    "aria-describedby": messageId,
    "data-testid": testAttrContent,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)('visually-hidden'),
      children: t("ui:notification.".concat(type))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: titleId,
      className: (0, _cnbuilder.cnb)(_NotificationModule.default.title, 'heading-xs'),
      children: title
    }), message && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: messageId,
      className: _NotificationModule.default.message,
      children: message
    }), actionButtonWithText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      onClick: onClick,
      children: buttonText
    })]
  });
  const closeButton = variant !== 'inline' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DismissButton.default, {
    className: _NotificationModule.default.dismiss,
    testAttr: testAttrDismiss,
    i18nLabel: i18nDismissLabel || t('ui:notification.dismiss'),
    onClick: closeToast,
    onFocus: onFocus
  });
  return variant === 'bell' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_NotificationModule.default.bellContent, {
        [_NotificationModule.default.bellContentRadius]: actionButtonWithText
      }),
      children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: message
      })]
    }), actionButtonWithText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      className: (0, _cnbuilder.cnb)(_NotificationModule.default.bellButton),
      onClick: onClick,
      children: buttonText
    })]
  }) : variant === 'inline' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cnbuilder.cnb)(_NotificationModule.default.root, _NotificationModule.default.body, _NotificationModule.default["".concat(type)], _NotificationModule.default.inline),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      className: _NotificationModule.default.icon
    }), notificationContent, closeButton]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      className: _NotificationModule.default.icon
    }), notificationContent, closeButton]
  });
};
Notification.defaultProps = {
  testAttrContent: 'notification-content',
  testAttrDismiss: 'notification-dismiss',
  type: 'info',
  showActionButton: true
};
var _default = exports.default = Notification;